import {
    type LogProposalTermsViewMutation,
    type LogProposalTermsViewMutationVariables,
} from 'generated/graphql';
import { LogProposalTermsViewDocument } from 'generated/documents/LogProposalTermsViewDocument';
import type { ServerErrorResponse } from '@modules/root/graphql/responses';
import { SuccessResponse } from '@modules/root/graphql/responses';
import { UserErrorResponse } from '@modules/root/graphql/responses';
import type { ActionFunctionArgs } from '~/types/route-args';

export const LOG_PROPOSAL_TERMS_VIEW_API_ROUTE =
    '/remix-api/log-proposal-terms-view';

export type LogProposalTermsViewAction =
    | SuccessResponse<{ logged: true }>
    | UserErrorResponse
    | ServerErrorResponse;

/**
 * Records when a customer opens terms and conditions on the proposal page.
 */
export const action = async ({ request, context }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const invoiceIdRaw = formData.get('invoiceId')?.toString();
    const termTitle = formData.get('termTitle')?.toString() ?? null;

    const invoiceID = invoiceIdRaw ? parseInt(invoiceIdRaw, 10) : 0;
    if (invoiceID <= 0) {
        throw new UserErrorResponse('Invoice ID is required');
    }

    const result = await context.client.mutate<
        LogProposalTermsViewMutation,
        LogProposalTermsViewMutationVariables
    >({
        mutation: LogProposalTermsViewDocument,
        variables: {
            InvoiceID: invoiceID,
            TermTitle: termTitle,
        },
    });

    if (result.errors?.length) {
        throw new UserErrorResponse(
            result.errors.map((error) => error.message).join(', '),
        );
    }

    if (result.data?.logProposalTermsView !== true) {
        throw new UserErrorResponse('Failed to log terms and conditions view');
    }

    return new SuccessResponse({ logged: true });
};
